import {ValueObject} from '@s-ui/domain'
import {toQueryString} from '@s-ui/js/lib/string'

export class SearchUrlFormValueObject extends ValueObject {
  #url

  constructor({url} = {}) {
    super()
    this.#url = url
  }

  static create = ({url}) => {
    return new SearchUrlFormValueObject({url})
  }

  static fromNextFieldAndParamsToValueObject = ({
    config,
    nextField,
    params: {bodyTypeDoors, ...restParams} = {}
  } = {}) => {
    const API_URL = config.get('API_URL')
    const DEFAULT_CATEGORY1_ID = config.get('search').DEFAULT_CATEGORY1_ID
    const NEXT_FIELD_API_PATHS = {
      bodytypes: 'body-types',
      fuels: 'fuel-types'
    }

    const cleanParams = (params = {}) => JSON.parse(JSON.stringify(params))
    const getResourceName = () => {
      const isMotos = config.get('APP_NAME') === config.get('APP_NAME_MOTOS')
      const _nextField = NEXT_FIELD_API_PATHS[nextField] ?? nextField

      // ff_web_seller_show_pta_multitenant
      if (isMotos) return `vehicle-specs/v1/dictionary/${_nextField}`
      if (_nextField !== 'makes') return `vehicle-specs/v1/${_nextField}/form`
      return `vehicle-specs/v1/${nextField}`
    }

    const requestParams = {section1Id: DEFAULT_CATEGORY1_ID, ...cleanParams(restParams)}
    if (bodyTypeDoors) {
      const [bodyTypeId, doors] = bodyTypeDoors.split('-')
      requestParams.bodyTypeId = bodyTypeId
      requestParams.doors = doors
    }

    const queryParams = toQueryString(requestParams)
    const url = `${API_URL}/${getResourceName()}?${queryParams}`

    return SearchUrlFormValueObject.create({url})
  }

  toJSON() {
    return {url: this.#url}
  }

  getUrl() {
    return this.#url
  }
}
